import React, { Component } from 'react'
import styled from 'styled-components'

export class HuaweiSport extends Component {

  postMessage = msg => {
    const stringify = JSON.stringify(msg)
    window.postMessage(stringify, '*')
  }
  parseUrl = () => {
    var searchHref = window.location.search.replace('?', '')
    var params = searchHref.split('&')
    var returnParam = {}
    params.forEach(function (param) {
      var paramSplit = param.split('=')
      returnParam[paramSplit[0]] = paramSplit[1]
    })
    if (returnParam && returnParam.authorization_code) {
      console.log('authorization_code====', returnParam.authorization_code)
      this.postMessage(returnParam.authorization_code)
    }
    return returnParam
  }

  render() {
    const param = this.parseUrl() || ''
    return (
      <RootView>
        <div onClick={() => {
          this.postMessage(param.authorization_code)
        }}>{param.authorization_code}</div>
      </RootView>
    )
  }
}

const RootView = styled.div`
  display: flex;
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
  width:100%;
  height:100%;
  padding-top: 20px;
  padding-bottom: 20px;
`



// WEBPACK FOOTER //
// ./src/modules/sport/components/HuaweiSport.js